import styled from "styled-components";
import colors from "../../../../theme/color/ColorTheme";
import fontSize from "../../../../theme/fonts/FontTheme";

const TableWrapper = styled.div`
  width: 50%;
  overflow-x: auto;
  background: #fff;
  border-radius: 8px;
  border: 1px solid ${colors.dash};
  border-bottom: none;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;
const TableHead = styled.thead`
  background-color: ${colors.backgroundTintSecondary};
`;
const Th = styled.th`
  padding: 16px;
  font-weight: 500;
  font-size: ${fontSize.s};
  color: #727272;
`;
const TableBody = styled.tbody``;

const Td = styled.td`
  padding: 14px 16px;
  font-size: ${fontSize.s};
  border-bottom: 1px solid ${colors.dash};
  vertical-align: middle;
  ${(props) =>
    props.type === "discount" &&
    `
    color: #FF0000;
  `}
  ${(props) =>
    props.type === "total" &&
    `
    font-weight: 500;
  `}
`;

const OrderPriceTable = ({ order }) => {
  return (
    <TableWrapper>
      <StyledTable>
        <TableHead>
          <tr>
            <Th>Order Summary</Th>
            <Th>Price</Th>
          </tr>
        </TableHead>
        <TableBody>
          <tr>
            <Td>Subtotal</Td>
            <Td>Rs. {Math.round(order.totalAmount - order.shippingFee)}</Td>
          </tr>
          <tr>
            <Td>Shipping</Td>
            <Td>Rs. {order.shippingFee}</Td>
          </tr>
          <tr>
            <Td type={"total"}>Total</Td>
            <Td type={"total"}>Rs. {Math.round(order.totalAmount)}</Td>
          </tr>
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
};

export default OrderPriceTable;
